<template>
  <a @click="onClick" :href="evt.location.url || null" tabindex="0" class="gmf-notif-event-row" :class="{'gmf-notif-event-row-unseen': evt.isUnseen}">
    <Avatar v-if="avatarCustomer" class="gmf-notif-event-row-image" :customer="avatarCustomer" disablePopup disableOnlineIndicator />
    <div v-else class="gmf-notif-event-row-image" :style="{backgroundImage: 'url(' + evt.imageUrl + ')'}"></div>
    <div class="gmf-notif-event-row-body">
      <div class="gmf-notif-event-text" v-html="text"></div>
      <div class="gmf-notif-event-date gmf-text-small" v-text="timeAgo((new Date(evt.date)).getTime() / 1000)"></div>
    </div>
    <div class="gmf-notif-event-row-dot"></div>
  </a>
</template>

<style>
.gmf-context .gmf-notif-event-row {
  display: flex !important;
  gap: var(--gmf-p-4);
  padding: var(--gmf-p-4);
  cursor: pointer;
  background: var(--gmf-col-white);
  transition: background 0.1s linear;
  border-radius: var(--gmf-rounding);
  text-decoration: none;
  color: var(--gmf-default-color);
}

.gmf-notif-event-row-unseen {
  color: var(--gmf-col-black) !important;
  background: var(--gmf-col-lightgray);
}

.gmf-notif-event-text {
  text-align: left;
  word-break: break-word;
}

.gmf-notif-event-row-unseen .gmf-notif-event-date {
  color: var(--gmf-brand-color) !important;
  font-weight: bold !important;
}
.gmf-notif-event-row-dot {
  opacity: 0;
  height: 12px;
  width: 12px;
  flex-grow: 0;
  flex-shrink: 0;
  background: var(--gmf-brand-color) !important;
  border-radius: 100%;
  align-self: center;
}
.gmf-notif-event-row-unseen .gmf-notif-event-row-dot {
  opacity: 1;
}

@media (hover: hover) {
  .gmf-context .gmf-notif-event-row:hover {
    background: var(--gmf-col-lightgray) !important;
  }
}

.gmf-notif-event-row-image {
  width: 50px;
  height: 50px;
  border-radius: var(--gmf-rounding);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
  flex-grow: 0;
}
.gmf-notif-event-row-image.gmf-avatar-3d.gmf-avatar-popout {
  width: 44px;
  height: 44px;
  margin: 3px;
}
.gmf-notif-event-row-body {
  display: flex;
  flex-direction: column;
  gap: var(--gmf-p-1);
  justify-content: center;
  flex-grow: 1;
  line-height: 1.4 !important;
}
.gmf-notif-event-date {
  align-self: flex-start;
}
</style>

<script>
import state from '@/state';
import openPostModal from '@/widgets/PostModal/openPostModal';
import timeAgo from '@/utils/timeAgo';
import getNotificationText from './getNotificationText';
import md from '@/utils/md';
import openPopupProfileCard from '@/components/PopupProfileCard/openPopupProfileCard';
import Avatar from '@/components/Avatar';

export default {
  props: {
    evt: {
      type: Object,
      required: true,
    },
    disableNavigation: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['notificationNavigation'],
  components: {
    Avatar,
  },
  methods: {
    timeAgo,
    onClick(e) {
      if (this.disableNavigation) {
        return;
      }
      this.$emit('notificationNavigation');

      if (this.contextData.commentType === 'marketplace') {
        e.stopPropagation();
        e.preventDefault();

        // @TODO if social feed url exists, go to that
        openPostModal(this.evt.location.ref);
        
        return false;
      } else if (this.evt.location.type === 'board') {
        e.stopPropagation();
        e.preventDefault();

        openPostModal(this.evt.location.ref);
        // @TODO if social feed url exists, go to that
        /*openSocialModal({
          filter: {
            board_id: this.evt.location.id,
          },
        });*/

        return false;
      } else if (this.evt.location.type === 'achievement' && this.hasDropdownProfileEnabled) {
        e.stopPropagation();
        e.preventDefault();

        openPopupProfileCard(undefined, 'achievements')

        return false;
      } else if (this.evt.location.ref) {
        e.stopPropagation();
        e.preventDefault();

        openPostModal(this.evt.location.ref);
      }
    },
  },
  computed: {
    avatarCustomer () {
      const cids = this.contextData.customers;
      const customer = cids && cids.length > 0 && cids[0];
      if (!customer) {
        if (this.contextData?.comment?.author) {
          return this.contextData.comment.author;
        }
        return false;
      }
      return customer;
    },
    contextData () {
      if (! this.evt.contextDataJson) {
        return {};
      }

      return JSON.parse(this.evt.contextDataJson) || {};
    },
    text () {
      const body = getNotificationText(this.evt) || this.evt.body;
      return md(body);
    },
    hasDropdownProfileEnabled() {
      return state.merchantConfig.widgets?.notifications?.types?.achievement_unlocked?.openInDropdownProfile;
    },
    isAchievementAndDropdownEnabled() {
      return this.evt.location.type === 'achievement' && this.hasDropdownProfileEnabled;
    }
  },
};
</script>
